export default class OnIndexSelectToggle {
	constructor({ elements }) {
		elements.forEach((el) => {
			this.el = el;
			this.toggleItem = el.dataset.toggleItem;
			el.addEventListener('change', (e) => {
				this.toggleSelectedItem(e.target?.selectedIndex);
			});
		});
	}

	toggleSelectedItem(selectedIndex) {
		const elementToToggle = document.querySelector(
			`[data-toggle-item="${this.toggleItem}-${selectedIndex}"]`
		);

		if (elementToToggle) {
			elementToToggle.classList.remove('hidden');
		} else {
			const elementToToggleOff = document.getElementById(`dataToggle-${this.toggleItem}`);
			elementToToggleOff.classList.add('hidden');
		}
	}
}
